export const SET_API_HOSTNAME = 'SET_API_HOSTNAME';
export const SET_API_PORT = 'SET_API_PORT';
export const SET_API_PROTOCOL = 'SET_API_PROTOCOL';
export const SET_API_BASE_PATH = 'SET_API_BASE_PATH';
export const RESET_APP_SETTINGS = 'RESET_APP_SETTINGS';